import { render, staticRenderFns } from "./TabCompose.vue?vue&type=template&id=721f9028&scoped=true"
import script from "./TabCompose.vue?vue&type=script&lang=ts"
export * from "./TabCompose.vue?vue&type=script&lang=ts"
import style0 from "./TabCompose.vue?vue&type=style&index=0&id=721f9028&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721f9028",
  null
  
)

export default component.exports